/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SendMailSouscriptionRecapMutation($input: SendMailWithDocuments_M_souscription_recapInput!) {
    sendMailSouscriptionRecap_M_souscription_recap(input: $input) {
      ok
      error
      
        canSendMail 
    }
  }
`;

export default mutation;
